import React from 'react';

import { TableRow } from '@mui/material';

import TrplsTableHeadCell from './TrplsTableHeadCell';
import { HighlightedTableCell } from './TableHighlighting';

import TrplCheckbox from '../../TrplControls/TrplCheckbox';

export default React.memo(({
  setup,
  account,
  tableId,
  isEmbed,
  classes,
  settings,
  scrolled,
  tableMenu,
  selectNode,
  setSorters,
  ancestorId,
  allOntNodes,
  individuals,
  hideColumns,
  searchValue,
  toggleColumn,
  selectedRows,
  restrictions,
  isDataLoaded,
  rowBorderBold,
  sortersValues,
  togglePopover,
  filterRstModal,
  initialSorters,
  onFilterBtnClick,
  rstAddFilterClick,
  setFiltersToState,
  onFilterSearchElemClick,
}) => {
  const showIndex = settings.show_index || tableId === ancestorId;
  const showTitle = settings.show_title || tableId === ancestorId;

  let isSelected = (selectedRows && individuals.query) ? selectedRows.some(e => individuals.query.includes(e)) : false;

  const cellClassName = `cell-index ${classes.indexCellStickyTop}
  ${allOntNodes ? classes.indexCellStickyTopWithMark : ''}
  ${isEmbed ? classes.embedTableTotalContainer : classes.tableTotalContainer}`;

  const nodeClassName = `cell-index ${classes.nodeCellStickyTop}
  ${isEmbed ? classes.embedTableTotalContainer : classes.tableTotalContainer}`;

  const ontologyMarkCell = `cell-mark ${classes.indexCellStickyTop}
  ${isEmbed ? classes.embedTableTotalContainer : classes.tableTotalContainer}`;

  return (
    <TableRow
      className={classes.tableStickyHeadRow}
      style={{ backgroundColor: '#fff', zIndex: 2 }}
    >
      {allOntNodes ?
        <HighlightedTableCell
          isMark={true}
          isHead={true}
          nodeId={null}
          ancestorId={ancestorId}
          tableId={tableId}
          rstChainId={null}
          cellClassName={ontologyMarkCell}
          classes={classes}
          resizable={false}
        >
        <div className={classes.tableTotal}/>
        </HighlightedTableCell>
      : null}

      {showIndex ? (
        <HighlightedTableCell
          isId={true}
          isHead={true}
          nodeId={null}
          ancestorId={ancestorId}
          tableId={tableId}
          rstChainId={null}
          cellClassName={cellClassName}
          classes={classes}
          resizable={false}
        >

        <div className={`${classes.tableTotal} ${classes.justifyCenter}`}>
          <span
            className="row-index-text"
            style={{
              color: '#4E4C4C',
              display: `${isSelected ? 'none' : ''}`,
            }}
          >
          #
          </span>
          <TrplCheckbox
            disableRipple
            value={isSelected}
            classes={{
              root: classes.rstCheckboxGray,
              label: classes.rstCheckboxLabel,
            }}
            checked={isSelected}
            onChange={(e) => selectNode(e.target.checked, 'all')}
            className={`row-checkbox ${classes.tableRowCheckbox}`}
            style={{
              padding: '0px 5px',
              display: `${isSelected ? 'flex' : ''}`,
              margin: 0,
            }}
          />
        </div>
        </HighlightedTableCell>
      ) : null}

      {showTitle ? (
        <HighlightedTableCell
          isTitle={true}
          isHead={true}
          //ref={(cell) => (this.cell = cell)}
          nodeId={null}
          tableId={tableId}
          ancestorId={ancestorId}
          rstChainId={null}
          cellClassName={nodeClassName}
          classes={classes}
          resizable={true}
        >
          <span className={classes.tableTotal}>
            {isDataLoaded && !isEmbed && individuals.query
              ? `${selectedRows.length ? selectedRows.length : individuals.query.length} / ${individuals.total_query}`
              : isDataLoaded && isEmbed && individuals.query && selectedRows.length
                ? `Selected: ${selectedRows.length} of ${individuals.query.length}`
                : isDataLoaded && isEmbed && individuals.query
                  ? `${individuals.query.length} / ${individuals.total_query}`
                  : ''}
          </span>
        </HighlightedTableCell>
      ) : null}

      {restrictions.map((rst, rIndex) => {
          const filterRstValue = filterRstModal.trpls[rst.id];
          const rstFilterNodeTitle = individuals.nodes[filterRstValue]
            ? individuals.nodes[filterRstValue].title
            : filterRstValue;

          return (
            <TrplsTableHeadCell
              rst={rst}
              key={rIndex}
              setup={setup}
              account={account}
              tableId={tableId}
              classes={classes}
              isEmbed={isEmbed}
              scrolled={scrolled}
              tableMenu={tableMenu}
              setSorters={setSorters}
              ancestorId={ancestorId}
              searchValue={searchValue}
              hideColumns={hideColumns}
              individuals={individuals}
              toggleColumn={toggleColumn}
              sortersValues={sortersValues}
              togglePopover={togglePopover}
              initialSorters={initialSorters}
              filterRstValue={filterRstValue}
              onFilterBtnClick={onFilterBtnClick}
              setFiltersToState={setFiltersToState}
              rstAddFilterClick={rstAddFilterClick}
              rstFilterNodeTitle={rstFilterNodeTitle}
              onFilterSearchElemClick={onFilterSearchElemClick}
            />
          );
        }
      )}

      {tableId ? (
        <HighlightedTableCell
          isEmptyCell={true}
          isHead={true}
          //ref={(cell) => (this.cell = cell)}
          nodeId={null}
          tableId={tableId}
          ancestorId={null}
          rstChainId={null}
          cellClassName={`${classes.tableCell} ${(
            classes.relative
          )} ${classes.stickyCell}
          )}`}
          classes={classes}
          resizable={false}
        >
        </HighlightedTableCell>
      ) : null}

    </TableRow>
  );
});
